export const getSubheading = (propertyData: Record<string, unknown>) => {
  let subheading = '';

  if (!propertyData.shortTermRental) {
    return null;
  }

  if (propertyData.shortTermRental) {
    subheading = 'Short-Term Rental';
  }

  if (propertyData.strLicense) {
    subheading += ' - Licensed';
  } else {
    subheading += ' - Unlicensed';
  }

  return subheading;
};
